export default "__VITE_ASSET___CkXkdA___"